import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { AlteracaoComprovante, JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class BoxInfoRouterService {

  clienteLocalEntrega = null;
  loadingLocalEntrega = false;
  loadingComprovante = false;
  dadosComprovante = null
  infoRouter: any;
  infoIntervalos: any;
  avisoAlteracao = '';
  alteracaoComprovante: Array<AlteracaoComprovante> = []
  exibirModalComprovante = false;
  constructor(
    private conService: ApiConService,
    private boxListTruckService: BoxListTruckService
  ) {

  }

  async getInfoRouter()
  {
    try
    {
      const response: JsonReturn = await this.conService.patch('DCroteiroPedido/' + this.boxListTruckService.roteiroSelecionado + '/0');
      this.infoRouter = response.response;

      this.infoRouter = this.infoRouter.map((element) => {
        element.ResumoNFeJSON = JSON.parse(element.ResumoNFeJSON);
        return element;
      })

      return this.infoRouter ;
    }
    catch (Error){
      console.log("CATCH________getInfoRouter");
      console.log(Error);
    }
  }

  async getInfoIntervalos() {
    try {
      const response: JsonReturn = await this.conService.patch('DCroteiroPedidoIntervalo/' + this.boxListTruckService.roteiroSelecionado);
      this.infoIntervalos = response.response;
     } catch (error) {
        console.log("CATCH________getInfoIntervalos");
        console.log(error);
     }
  }

  async getComprovante(IdPedidoConfirmacaoEntrega) {
    this.loadingComprovante = true;
    try {
      const response = await this.conService.patch('DCPedidoConfirmacaoEntrega/' + IdPedidoConfirmacaoEntrega);
      return response.response.find((element) => element.Arquivo != null)
     } catch (error) { 
      console.log("Erro ao carragar comprovante")
     }finally{
      this.loadingComprovante = false;
     }
  }

  async getComprovanteLocalEntrega(clienteID: number, numeroRoteiro: number) {
    try {
      this.loadingLocalEntrega = true;
      const response: any= await this.conService.patch(`DCPedidoConfirmacaoEntrega/localEntrega/${numeroRoteiro}/${clienteID}`);   
      return response.arquivo;
     } catch (error) { 
      console.log("Erro ao carragar comprovante Img")
     } finally{
      this.loadingLocalEntrega = false;
     }
  }


    async getAlteracaoComprovante(idRoteiro: number, idroteiroPedido: number) {
    this.loadingComprovante = true;
    try {
      this.avisoAlteracao = ''
      const response = await this.conService.patch('DCAlteracaoComprovante/' + idRoteiro + '/' + idroteiroPedido);
      this.alteracaoComprovante = response.response;
      if(this.alteracaoComprovante.length){
        const data = new Date(this.alteracaoComprovante[0].DT);
        const dataFormatada = `${String(data.getUTCDate()).padStart(2, '0')}/${String(data.getUTCMonth() + 1).padStart(2, '0')}/${data.getUTCFullYear()}`;
        const horaFormatada = `${String(data.getUTCHours()).padStart(2, '0')}:${String(data.getUTCMinutes()).padStart(2, '0')}`;
        this.avisoAlteracao = `Usuário ${this.alteracaoComprovante[0].Usuario} atualizou o comprovante na data ${dataFormatada} às ${horaFormatada}.`;
      }

     } catch (error) { 
      console.log("Erro ao carragar alteracao comprovante")
     }finally{
      this.loadingComprovante = false;
     }
  }



}